import { render, staticRenderFns } from "./CreatePackageApplication.vue?vue&type=template&id=4a98a62e&"
import script from "./CreatePackageApplication.vue?vue&type=script&lang=js&"
export * from "./CreatePackageApplication.vue?vue&type=script&lang=js&"
import style0 from "./CreatePackageApplication.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports